import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { NAV_ITEMS } from "../lib/navConfig";

/**
 * @param {{ variant?: "solid" | "overlay", current?: string }} props
 */
export default function SiteNav({ variant = "solid", current = "home" }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const rootRef = useRef(null);
  const overlay = variant === "overlay";

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const onDocumentClick = (event) => {
      const root = rootRef.current;
      if (!root) return;
      if (!root.contains(event.target)) {
        closeMenu();
      }
    };

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closeMenu();
      }
    };

    document.addEventListener("click", onDocumentClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("click", onDocumentClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [menuOpen, closeMenu]);

  return (
    <header
      ref={rootRef}
      className={`site-nav-header site-nav-header--${variant}`}
    >
      <div className={`site-nav-bar${overlay ? " site-nav-bar--overlay" : ""}`}>
        <Link
          to="/"
          aria-label="CJ.PHOTOS home"
          className="site-nav-logo-link"
          onClick={closeMenu}
        >
          <img
            src={`${process.env.PUBLIC_URL}/uploads/cj-mark.svg`}
            alt="CJ.PHOTOS"
            className={`site-nav-logo${overlay ? " site-nav-logo--overlay" : ""}`}
          />
        </Link>

        <button
          type="button"
          className={`site-nav-menu-btn${overlay ? " site-nav-menu-btn--overlay" : ""}${menuOpen ? " is-open" : ""}`}
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={(event) => {
            event.stopPropagation();
            setMenuOpen((open) => !open);
          }}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div
        className={`site-nav-dropdown${menuOpen ? " is-open" : ""}`}
        aria-hidden={!menuOpen}
      >
        {NAV_ITEMS.map((item) =>
          item.key === current ? (
            <span key={item.key} className="site-nav-dropdown__item site-nav-dropdown__item--current">
              {item.label}
              <span className="site-nav-dropdown__current">CURRENT</span>
            </span>
          ) : (
            <Link
              key={item.key}
              to={item.href}
              className="site-nav-dropdown__item site-nav-dropdown__item--link"
              onClick={closeMenu}
            >
              {item.label}
              <span className="site-nav-dropdown__arrow" aria-hidden="true">
                →
              </span>
            </Link>
          )
        )}
      </div>
    </header>
  );
}
